import { gql } from 'urql';

const FetchSavingsAPY = gql`
  query Lookup {
    lookup {
      savingsApy
    }
  }
`;

export default FetchSavingsAPY;
